// 编写具体api的实现
import axios from "axios";
import {getToken} from "@/utils/auth";
import {Message} from "element-ui";
import errorCode from "@/utils/errorCode";
import {handleSessionExpired} from "@/utils/session";


const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: 'http://localhost:4567',
  timeout: 5000,
});
// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    // console.log("request拦截器")
    // 是否需要设置 token
    const isToken = (config.headers || {}).isToken === false;
    if (getToken() && !isToken) {
      config.headers["Authorization"] = "Bearer " + getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // 在发送请求之前做些什么
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  function (res) {
    // console.log("response拦截器", res.data)
    // 2xx 范围内的状态码都会触发该函数。
    // 未设置状态码则默认成功状态
    const code = res.data.code || 200;
    // 获取错误信息
    const msg = errorCode[code] || res.data.msg || errorCode["default"];
    // 二进制数据则直接返回
    if (
      res.request.responseType === "blob" ||
      res.request.responseType === "arraybuffer"
    ) {
      return res.data;
    }

    const token = getToken();
    if (code === 401) {
      handleSessionExpired();
      const errorMsg = token
        ? "无效的会话，或者会话已过期，请重新登录。"
        : "未登录，请先登录。";
      return Promise.reject(errorMsg);
    }else if (code === 400) {
      console.log("请求参数错误", code);
      Message({ message: msg, type: "error" });
      return Promise.reject(new Error(msg));
    } else if (code === 500) {
      console.log("服务器内部错误", code);
      Message({ message: msg, type: "error" });
      return Promise.reject(new Error(msg));
    } else if (code === 601) {
      Message({ message: msg, type: "warning" });
      return Promise.reject("error");
    } else if (code !== 200) {
      Notification.error({ title: msg });
      return Promise.reject("error");
    } else {
      return res.data;
    }
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    let { message } = error;
    if (message === "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }

    Message({ message: message, type: "error", duration: 5 * 1000 });
    return Promise.reject(error);
  }
);

export default instance;
